import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import "./FastBooking.css"
import FastBookingController from './FastBookingController';
import CircularSpinner from 'mmbclient/Components/CircularSpinner';
import { getCookie } from 'mmbclient/Common/CommonFunctions';
import { AD, APP_TYPE_COOKIE_NAME, EP, MMB, MMB_LIVE, USER_TYPE_COOKIE_NAME } from 'mmbclient/Common/CommonVariable';

function FastBooking() {
    const {formValues,loading,setFormValues,setLoading,setDate,originPin,filteredOriginPincodes,setFilteredOriginPincodes,filteredDestPincodes,setFilteredDestPincodes,handleBlurPincode,pincodeList,handleInputChange,client,setClient,clientOption,service,network,activeOriginIndex,setActiveOriginIndex,selectOriginPincode,selectDestPincode,setActiveDestIndex,activeDestIndex,handleDecimalInputChange,handleNumberInputChange,checkValidation,resetAction,awbBlurHandle,betterLoggerFunction,activeConsigneeIndex,setActiveConsigneeIndex,filterConsignee,selectConsignee,setFilterConsignee,weigthDimension,setWeigthDimension,enterDimensionMMB_LIVE,enterDimensionMMB,handleWeigthDecimalInputChange,dimensionList,setDimensionList,showDimensionWeigthModal,setShowDimensionWeigthModal,disableAwb,handleWeigthDimenstionFocus,isSaveDisable,removeEnteredDimension,showEWayBillModal,setShowEWayBillModal,eWayBillList,setEWayBillLIst,enterEWayBillNumber,ewaybillObj,removeEnteredEWayBill,handleEWayBillFocus,handleBlurOfVolumeWt,printDocket,handleEnterAsTab, dateRef} = FastBookingController();
    const [showModal, setShowModal] = useState(false);
    


    const isCashOrCredit = formValues.paymentType === 'CA' || formValues.paymentType === 'Credit';
    const isCOD = formValues.paymentType === 'COD';
    const isFOD = formValues.paymentType === 'FOD';
    const isCODFOD = formValues.paymentType === 'CODFOD';

    useEffect(() => {
        const type = formValues.paymentType;

        setFormValues(prev => {
            switch (type) {
                case 'CA':
                case 'Credit':
                    return {
                        ...prev,
                        fodAmount: 0,
                        fodValue: 0,
                        codAmount: 0,
                        codValue: 0,
                    };

                case 'COD':
                    return {
                        ...prev,
                        fodAmount: 0,
                        fodValue: 0,
                        amount: 0
                    };

                case 'FOD':
                    return {
                        ...prev,
                        codAmount: 0,
                        codValue: 0,
                        amount: 0
                    };

                case 'CODFOD':
                    return {
                        ...prev,
                        amount: 0
                    };

                default:
                    return prev;
            }
        });

    }, [formValues.paymentType]);

   return (
    <>   

        {/* Bootstrap Modal */}
        <div className={`modal fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden={!showModal}>
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    {/* <div className={`modal-header alert-${modalType}`}> */}
                    <div className={`modal-header alert-primary d-flex justify-content-between`}>
                        <h5 className="modal-title" id="modalLabel">Alert</h5>
                        <button type="button" className="close" onClick={() => setShowModal(false)} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {/* {modalMessage} */}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div onMouseOver={betterLoggerFunction}>
            <div className='container mt-2'>
                {loading && <CircularSpinner />}
                <h1 className='text-center'>Fast Booking</h1>
                <section className="border p-3 mb-4 form-control">
                    <form className='p-2' onKeyDown={handleEnterAsTab}>
                        <div className='row mb-3 align-items-center'>
                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>
                                    Awb No.
                                    <span className='text-danger'>*</span>
                                </label>
                                <input
                                type="text"
                                name="awbNo"
                                className="form-control"
                                placeholder="Enter awb no."
                                value={formValues.awbNo}
                                onChange={handleInputChange}
                                onBlur={awbBlurHandle}
                                disabled = {disableAwb}
                                maxLength={20}
                                /> 
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>
                                    Forwarding No.
                                </label>
                                <input 
                                type='text' 
                                name="forwardingNo"
                                className='form-control' 
                                placeholder='Enter forwarding no.'
                                maxLength={20}
                                value={formValues.forwardingNo}
                                onChange={handleInputChange}/>
                            </div>  

                            <div className='col-md-2'>
                                <label className='form-label'>
                                    Date
                                </label>
                                <DatePicker 
                                selected={formValues.date}
                                name='date' 
                                onChange={(date)=> {
                                    setFormValues(prev=>({
                                        ...prev,
                                        date:date
                                    }))   
                                }}
                                ref={dateRef}
                                className='form-control'
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                                maxDate={new Date()}
                                />
                            </div>

                            {
                                (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)?
                                <div className='col-md-4 mb-2'>
                                <label className='form-label'>Client
                                    <span className='text-danger'>*</span>
                                </label>
                                <select className='form-control'
                                value={formValues.client}
                                name='client'
                                onChange={e=>{
                                    // setClient(e.target.value)
                                    handleInputChange(e);
                                    }}>
                                    {clientOption.length>0 && 
                                    clientOption.map((option,index)=>(
                                        <option key={index} value={option}>{option}</option>
                                    ))}
                                </select>
                            </div>
                            :
                            <div className='col-md-4 mb-2'>
                                <label className='form-label'>Client
                                    <span className='text-danger'>*</span>
                                </label>
                                <select className='form-control'
                                value={formValues.client}
                                name='client'
                                onChange={e=>{
                                    // setClient(e.target.value)
                                    handleInputChange(e);
                                    }}>
                                    {clientOption.length>0 && 
                                    clientOption.map((option,index)=>(
                                        <option key={index} value={option}>{option}</option>
                                    ))}
                                </select>
                                {/* <input name = "client" value={client} onChange={handleInputChange} className='form-control' disabled/> */}
                            </div>
                            }

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>
                                    Sub Client
                                </label>
                                <input type='text' 
                                name='subClient'
                                value={formValues.subClient}
                                onChange={handleInputChange}
                                maxLength={30}
                                className='form-control' placeholder='Enter sub client'/>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>Network
                                    <span className='text-danger'>*</span>
                                </label>
                                <select className='form-control'
                                name='network'
                                value={formValues.network}
                                onChange={handleInputChange}>
                                    {network.length>0 &&
                                    network.map((item,index)=>(
                                        <option key={index} value={item}>{item}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>Service
                                    <span className='text-danger'>*</span>
                                </label>
                                <select className='form-control'
                                value={formValues.service}
                                name='service'
                                onChange={e=>{
                                    handleInputChange(e)
                                }}>
                                    {service.length>0 &&
                                    service.map((item,index)=>(
                                        <option key={index} value={item}>{item}</option>
                                    ))};
                                </select>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>Origin Pincode
                                    <span className='text-danger'>*</span>
                                </label>
                                <div style={{position:"relative"}}>
                                    <input 
                                    className='form-control' 
                                    name='originPincode'
                                    autoComplete='off'
                                    placeholder='Enter origin pincode'
                                    value={formValues.originPincode}
                                    onChange={e=>{
                                        handleInputChange(e);
                                        setActiveDestIndex(-1);
                                    }}
                                    
                                    onBlur={e=>{
                                        handleBlurPincode('originPincode');
                                        setTimeout(() => setFilteredOriginPincodes([]), 100);
                                    }}
                                    onKeyDown={(e)=>{
                                        if(e.key==="Tab"){
                                            setFilteredOriginPincodes([]);
                                            return;
                                        }
                                        else if (e.key === 'ArrowDown') {
                                            e.preventDefault();
                                            setActiveOriginIndex((prev) =>
                                                prev < filteredOriginPincodes.length - 1 ? prev + 1 : prev
                                            );
                                        } else if (e.key === 'ArrowUp') {
                                            e.preventDefault();
                                            setActiveOriginIndex((prev) => (prev > 0 ? prev - 1 : 0));
                                        } 
                                        // else if (e.key === 'Enter') {
                                        //     e.preventDefault();
                                        //     if (
                                        //         activeOriginIndex >= 0 &&
                                        //         activeOriginIndex < filteredOriginPincodes.length
                                        //     ) {
                                        //         selectOriginPincode(filteredOriginPincodes[activeOriginIndex]);
                                        //     }
                                        // }
                                    }}
                                    />
                                    {filteredOriginPincodes.length>0 && (
                                        <ul className='autocomplete'>
                                            {filteredOriginPincodes.map((pin,index)=>(
                                                <li 
                                                className={index === activeOriginIndex?"active":""} 
                                                onMouseDown={() => selectOriginPincode(pin)}
                                                key={index}
                                                >{pin}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>Origin City</label>
                                <input type='text' className='form-control'
                                name="originCity"
                                value={formValues.originCity}
                                onChange={handleInputChange}
                                
                                disabled/>
                            </div>
        {/* simple right now */}
                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>Destination Pincode
                                    <span className='text-danger'>*</span>
                                </label>
                                <div style={{position:"relative"}}>
                                    <input 
                                    className='form-control' 
                                    name = "destPincode" 
                                    autoComplete='off'
                                    placeholder='Enter Destination pincode'
                                    value={formValues.destPincode}
                                    onChange={e=>{
                                        handleInputChange(e);
                                        setActiveDestIndex(-1);
                                    }}
                                    onBlur={e=>{
                                        handleBlurPincode('destPincode');
                                        setTimeout(() => setFilteredDestPincodes([]), 100);
                                    }}
                                    onKeyDown={(e)=>{
                                        if(e.key==="Tab"){
                                            setFilteredOriginPincodes([]);
                                            return;
                                        }
                                        else if (e.key === 'ArrowDown') {
                                            e.preventDefault();
                                            setActiveDestIndex((prev) =>
                                                prev < filteredDestPincodes.length - 1 ? prev + 1 : prev
                                            );
                                        } else if (e.key === 'ArrowUp') {
                                            e.preventDefault();
                                            setActiveDestIndex((prev) => (prev > 0 ? prev - 1 : 0));
                                        } 
                                        // else if (e.key === 'Enter') {
                                        //     e.preventDefault();
                                        //     if (
                                        //         activeDestIndex >= 0 &&
                                        //         activeDestIndex < filteredDestPincodes.length
                                        //     ) {
                                        //         selectDestPincode(filteredDestPincodes[activeDestIndex]);
                                        //     }
                                        // }
                                    }}
                                    />
                                    {filteredDestPincodes.length>0 && (
                                        <ul className='autocomplete'>
                                            {filteredDestPincodes.map((pin,index)=>(
                                                <li className={activeDestIndex===index?"active":""} key={index}
                                                onMouseDown={() => selectDestPincode(pin)}
                                                >{pin}</li>
                                            ))}
                                        </ul>
                                    )}
                                    
                                </div>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>Destination City</label>
                                <input 
                                className='form-control' 
                                name='destCity'
                                value={formValues.destCity}
                                onChange={handleInputChange}
                                disabled/>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='label-form'>State Code</label>
                                <input className='form-control' 
                                name='stateCode'
                                value={formValues.stateCode}
                                onChange={handleInputChange}
                                disabled></input>
                            </div>

                            <div className="col-md-2 mb-2">
                                <label className="form-label">Type
                                    <span className='text-danger'>*</span>
                                </label>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        id="dox"
                                        name="docType"
                                        value="dox"
                                        className="form-check-input"
                                        checked={formValues.docType === 'dox'}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="dox" className="form-check-label">Dox</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        id="non-dox"
                                        name="docType"
                                        value="non-dox"
                                        className="form-check-input"
                                        checked={formValues.docType === 'non-dox'}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="non-dox" className="form-check-label">Non-Dox</label>
                                </div>
                            </div>

                            <div className='col-md-2 mb-2'>
                                    <label className='label-form'>PCS
                                        <span className='text-danger'>*</span>
                                    </label>
                                    <input className='form-control' 
                                    name='pcs'
                                    value={formValues.pcs}
                                    onChange={handleNumberInputChange}
                                    placeholder='Enter pcs'
                                    />
                                </div>
                        </div>

                        {/* <div className='row mb-3 align-items-center'>

                        </div> */}

                        <div className='row mb-3 align-items-center'>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>Actual Weigth</label>
                                <input className='form-control'
                                name='actualWt'
                                value={formValues.actualWt}
                                onChange={handleDecimalInputChange}
                                placeholder='Enter actual weigth'></input>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>Volume Weigth</label>
                                <input className='form-control' 
                                name='volumneWt'
                                value={formValues.volumneWt}
                                onChange={handleDecimalInputChange}
                                placeholder='Enter volume weigth'
                                onBlur={handleBlurOfVolumeWt}
                                onKeyDown={(e) => {
                                    if ((e.key === 'v' || e.key === 'V')) {
                                        e.preventDefault();   // optional (prevents typing Y)
                                        handleWeigthDimenstionFocus()
                                        formValues.awbNo.trim()!=='' &&
                                        0<Number(formValues.pcs)?setShowDimensionWeigthModal(true):setShowDimensionWeigthModal(false);
                                    }
                                }}/>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>Billing Weigth</label>
                                <input className='form-control' 
                                name='billingWt'
                                value={formValues.billingWt}
                                onChange={handleDecimalInputChange}
                                disabled></input>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>Ins. Invoice No.</label>
                                <input className='form-control' 
                                name='insInvoiceNo'
                                value={formValues.insInvoiceNo}
                                onChange={handleInputChange}
                                placeholder='Enter ins. invoice no.'></input>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>Ins. Value</label>
                                <input className='form-control' 
                                name='insValue'
                                value={formValues.insValue}
                                onChange={handleDecimalInputChange}
                                placeholder='Enter ins. value'></input>
                            </div>
                        </div>

                        <div className='row mb-3 align-item-center'>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>
                                    Payment Type
                                    <span className='text-danger'>*</span>
                                </label>
                                <select className='form-control' name='paymentType' value={formValues.paymentType} 
                                onChange={e=>{
                                    handleInputChange(e);
                                    // paymentOnChange();
                                    }}>
                                    <option value={"Credit"}>Credit</option>
                                    <option value={"CA"}>Cash</option>
                                    <option value={"COD"}>Cheque Collect Amount</option>
                                    <option value={"FOD"}>Fod</option>
                                    <option value={"CODFOD"}>Fod & Cheque Collect Amount</option>
                                </select>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>
                                    Amount
                                </label>
                                <input className='form-control' 
                                name='amount'
                                value={formValues.amount}
                                onChange={handleDecimalInputChange}
                                disabled={!isCashOrCredit}/>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>
                                    Cheuqe Collect Value
                                </label>
                                <input className='form-control' 
                                name='codValue'
                                value={formValues.codValue}
                                onChange={handleDecimalInputChange}
                                disabled={!(isCOD || isCODFOD)}/>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>
                                    Cheque Collect Amount
                                </label>
                                <input className='form-control' 
                                name='codAmount'
                                value={formValues.codAmount}
                                onChange={handleDecimalInputChange}
                                disabled={!(isCOD || isCODFOD)}/>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>
                                    Fod Value
                                </label>
                                <input className='form-control' 
                                name='fodValue'
                                value={formValues.fodValue}
                                onChange={handleDecimalInputChange}
                                disabled={!(isFOD || isCODFOD)}/>
                            </div>

                            <div className='col-md-2 mb-2'>
                                <label className='form-label'>
                                    Fod Amount
                                </label>
                                <input className='form-control' 
                                name='fodAmount'
                                value={formValues.fodAmount}
                                onChange={handleDecimalInputChange}
                                disabled={!(isFOD || isCODFOD)}/>
                            </div>

                        </div>

                        <div className='row mb-3 align-item-center'>

                            <div className='col-md-3 mb-2'>
                                <label className='form-label'>
                                    E-Way Bill
                                </label>
                                <input className='form-control' 
                                name='ewayBill'
                                value={formValues.ewayBill}
                                onKeyDown={e=>{
                                    if(formValues.awbNo && (e.key==='E'||e.key==='e') && getCookie(APP_TYPE_COOKIE_NAME)===MMB_LIVE){
                                        handleEWayBillFocus();
                                        setShowEWayBillModal(true);
                                    }
                                }}
                                placeholder='Enter e-way bill'/>
                            </div>

                            <div className='col-md-3 mb-2'>
                                <label className='form-label'>Content</label>
                                <input className='form-control' 
                                name='content'
                                value={formValues.content}
                                onChange={handleInputChange}
                                maxLength={50}
                                placeholder='Enter Content'></input>
                            </div>

                            <div className='col-md-5 mb-2'>
                                <label className='form-label'>Remarks</label>
                                <input className='form-control' 
                                name='remarks'
                                value={formValues.remarks}
                                onChange={handleInputChange}
                                maxLength={150}
                                placeholder='Enter remarks'/>
                            </div>
                        </div>

                        <div className='row mb-3 align-item-center'>

                            <div className='col md-3 mb-2'>
                                <label className='form-label'>
                                    Consignee
                                </label>
                                <div style={{position:"relative"}}>
                                    <input 
                                    className='form-control' 
                                    name = "consignee" 
                                    autoComplete='off'
                                    placeholder='Enter consignee'
                                    value={formValues.consignee}
                                    maxLength={248}
                                    onChange={e=>{
                                        handleInputChange(e);
                                        setActiveConsigneeIndex(-1);
                                    }}
                                    onBlur={e=>{
                                        setTimeout(() => setFilterConsignee([]), 100);
                                    }}
                                    onKeyDown={(e)=>{
                                        if(e.key==="Tab"){
                                            setActiveConsigneeIndex([]);
                                            return;
                                        }
                                        else if (e.key === 'ArrowDown') {
                                            e.preventDefault();
                                            setActiveConsigneeIndex((prev) =>
                                                prev < filterConsignee.length - 1 ? prev + 1 : prev
                                            );
                                        } else if (e.key === 'ArrowUp') {
                                            e.preventDefault();
                                            setActiveConsigneeIndex((prev) => (prev > 0 ? prev - 1 : 0));
                                        } 
                                        // else if (e.key === 'Enter') {
                                        //     e.preventDefault();
                                        //     if (
                                        //         activeConsigneeIndex >= 0 &&
                                        //         activeConsigneeIndex < filterConsignee.length
                                        //     ) {
                                        //         selectConsignee(filterConsignee[activeConsigneeIndex]);
                                        //     }
                                        // }
                                    }}
                                    />
                                    {filterConsignee.length>0 && (
                                        <ul className='autocomplete'>
                                            {filterConsignee.map((pin,index)=>(
                                                <li className={activeConsigneeIndex===index?"active":""} key={index}
                                                onMouseDown={() => selectConsignee(pin)}
                                                >{pin}</li>
                                            ))}
                                        </ul>
                                    )}
                                    
                                </div>
                            </div>
                        </div>

                        
                        <div className="d-flex justify-content-center mt-4">
                            <div className='col-md-2 mb-2 me-5 secondary'>
                                <label className='form-label font-18px d-flex align-items-center gap-2'>
                                    <input
                                        type='checkbox'
                                        className='form-check-input checkInput'
                                        name='printDocket'
                                        checked={printDocket}
                                        onChange={handleInputChange}
                                    />
                                    Print
                                </label>
                            </div>

                            <button type="button" className="btn btn-primary me-5" name='saveBtn' style={{ width: "120px" }} onClick={checkValidation} disabled={isSaveDisable}>
                                Save
                            </button>
                            <button type="button" className="btn btn-secondary" style={{ width: "120px" }} onClick={resetAction}>
                                Reset
                            </button>
                        </div>
                    </form>
                </section>
            </div>

            {showDimensionWeigthModal && (
                <>
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title">Weigth Dimension Calculator</h5>
                                    <button 
                                        type="button" 
                                        className="btn-close" 
                                        onClick={() => setShowDimensionWeigthModal(false)}
                                    ></button>
                                </div>

                                <div className="modal-body">
                                    <div className='row mb-3 align-item-center'>

                                        <div className='col-md-2 mb-2'>
                                            <label className='form-label'>
                                                PCS
                                            </label>
                                            <input className='form-control'
                                            value={weigthDimension.pcs} 
                                            onChange={handleWeigthDecimalInputChange}
                                            name='pcs'
                                            // disabled
                                            />
                                        </div>

                                        <div className='col-md-2 mb-2'>
                                            <label className='form-label'>Heigth</label>
                                            <input className='form-control' 
                                            name='heigth'
                                            value={weigthDimension.heigth}
                                            onChange={handleWeigthDecimalInputChange}
                                            />
                                        </div>

                                        <div className='col-md-2 mb-2'>
                                            <label className='form-label'>Width</label>
                                            <input className='form-control' 
                                            name='width'
                                            value={weigthDimension.width}
                                            onChange={handleWeigthDecimalInputChange}
                                            />
                                        </div>
                                        <div className='col-md-2 mb-2'>
                                            <label className='form-label'>Length</label>
                                            <input className='form-control' 
                                            name='length'
                                            value={weigthDimension.length}
                                            onChange={handleWeigthDecimalInputChange}
                                            />
                                        </div>
                                        <div className='col-md-2 mb-2'>
                                            <label className='form-label'>Act Wt</label>
                                            <input className='form-control' 
                                            name='actwt'
                                            value={weigthDimension.actwt}
                                            onChange={handleWeigthDecimalInputChange}
                                            onKeyDown={(e)=>{
                                                if(e.key==='Enter' && getCookie(APP_TYPE_COOKIE_NAME)=== MMB_LIVE){
                                                    enterDimensionMMB_LIVE();
                                                }else if(e.key==='Enter' && getCookie(APP_TYPE_COOKIE_NAME)=== MMB){
                                                    enterDimensionMMB();
                                                }
                                            }}
                                            />
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table table-sm table-bordered table-striped text-center align-middle">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th style={{width: "60px"}}>S.No</th>
                                                            <th style={{width: "80px"}}>PCS</th>
                                                            <th>Height</th>
                                                            <th>Width</th>
                                                            <th>Length</th>
                                                            <th>Act Wt</th>
                                                            <th>Vol Wt</th>
                                                            <th>Remove</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {dimensionList?.length > 0 ? (
                                                            dimensionList.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.pcs}</td>
                                                                    <td>{item.heigth}</td>
                                                                    <td>{item.width}</td>
                                                                    <td>{item.length}</td>
                                                                    <td>{item.actwt}</td>
                                                                    <td>{item.volwt}</td>
                                                                    <td><button className="btn btn-secondary" 
                                                                    onClick={()=>removeEnteredDimension(index)}
                                                                    disabled={isSaveDisable}>remove</button></td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="8" className="text-muted">
                                                                    No Data Added
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Background Overlay */}
                    <div className="modal-backdrop fade show"></div>
                </>
            )}

            {showEWayBillModal && (
                <>
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title">Add E-Way Bill Number</h5>
                                    <button 
                                        type="button" 
                                        className="btn-close" 
                                        onClick={() => setShowEWayBillModal(false)}
                                    ></button>
                                </div>

                                <div className="modal-body">
                                    <div className='row mb-3 align-item-center'>

                                        <div className='col-md-3 mb-2'>
                                            <label className='form-label'>
                                                AWB No.
                                            </label>
                                            <input className='form-control'
                                            value={formValues.awbNo} 
                                            name='awbNo'
                                            disabled
                                            />
                                        </div>
                                        <div className='col-md-4 mb-2'>
                                            <label className='form-label'>E-Way Bill</label>
                                            <input className='form-control' 
                                            maxLength={12}
                                            name='ewayBill'
                                            placeholder='Enter eway bill'
                                            value={ewaybillObj.ewayBill}
                                            onChange={handleNumberInputChange}
                                            />
                                        </div>
                                        <div className='col-md-2 mb-2'>
                                            <label className='form-label'>API</label>
                                            <input
                                            type='checkbox'
                                            className='form-check-input'
                                            name='ewaybillapi'
                                            checked={ewaybillObj.ewaybillapi}
                                            onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className='col-md-2 mb-2'>
                                            <label className='form-label'></label>
                                            <button className="btn btn-primary"
                                            onClick={enterEWayBillNumber}
                                            onKeyDown={(e)=>{
                                                if(e.key==='Enter'){
                                                    enterEWayBillNumber();
                                                }
                                            }}>Add</button>
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table table-sm table-bordered table-striped text-center align-middle">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th style={{width: "60px"}}>S.No</th>
                                                            <th>EWay Bill</th>
                                                            <th>Inv No.</th>
                                                            <th>Inv Date</th>
                                                            <th>Inv Value</th>
                                                            <th>Validity</th>
                                                            <th>Remove</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {eWayBillList?.length > 0 ? (
                                                            eWayBillList.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.ewayBill}</td>
                                                                    <td>{item.invNo}</td>
                                                                    <td>{item.invDate}</td>
                                                                    <td>{item.invValue}</td>
                                                                    <td>{item.validity}</td>
                                                                    <td><button className="btn btn-secondary"
                                                                    onClick={()=>removeEnteredEWayBill(index)}
                                                                    disabled={isSaveDisable}>remove</button></td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="7" className="text-muted">
                                                                    No Data Added
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Background Overlay */}
                    <div className="modal-backdrop fade show"></div>
                </>
            )}

        </div>
    </>
  )
}

export default FastBooking
